<template>

    <section class="checkout-section basket">
        <h1><span>1. </span>Confirm your order</h1>
        <table>
            <colgroup>
                <col span="1" rel="product">
                <col span="1" rel="quantity">
                <col span="1" rel="price">
            </colgroup>
            <thead>
                <tr>
                    <th>Product</th>
                    <th>Quantity</th>
                    <th>Price</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in basket.rows">
                    <td :id="row.rowId">
                        <div>
                            <figure>
                                <img :src="row.cover" :alt="row.name">
                            </figure>
                            <h4>{{ row.name }}</h4>
                        </div>
                    </td>
                    <td>
                        <div>
                            <input type="number" step="1" min="1" max="99" v-model.number="row.qty" @keypress="onlyAllowNumeric($event, row)" @change="$emit('updated', row)" :disabled="row.disable_qty_update">
                        </div>
                    </td>
                    <td>
                        <div>
                            &pound{{ row.subtotal}}
                            <button class="basket-ctl delete-row" @click="$emit('deleted', row.rowId)"></button>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td colspan="2">
                        <table id="basket-totals">
                            <tbody>
                                <tr>
                                    <th>Subtotal</th>
                                    <td>{{ $filters.getCurrencyValue(basket.subtotal) }}</td>
                                </tr>
                                <tr>
                                    <th>Shipping</th>
                                    <td>{{ $filters.getCurrencyValue(basket.shipping_cost) }}</td>
                                </tr>
                                <tr>
                                    <th>Total</th>
                                    <td>{{ $filters.getCurrencyValue(basket.total) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tfoot>
        </table>
    </section>

</template>

<script>

export default {

	data(){
		return {

        }
    },
    props: [
    	'basket'
    ],
    mounted(){

    },
    methods: {
        onlyAllowNumeric(evt, row)
        {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            }else{

                return true;
            }
        }
    }
}

</script>
